/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";
export type infoAddContactLinkInput = {
    clientMutationId?: string | null;
    entityType: string;
    entitySlug: string;
    role: string;
    contactSlug: string;
    assign?: boolean | null;
    commandCall?: boolean | null;
};
export type SearchContactsAddMutationVariables = {
    input: infoAddContactLinkInput;
};
export type SearchContactsAddMutationResponse = {
    readonly infoAddContactLink: {
        readonly clientMutationId: string | null;
    } | null;
};
export type SearchContactsAddMutation = {
    readonly response: SearchContactsAddMutationResponse;
    readonly variables: SearchContactsAddMutationVariables;
};



/*
mutation SearchContactsAddMutation(
  $input: infoAddContactLinkInput!
) {
  infoAddContactLink(input: $input) {
    clientMutationId
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "infoAddContactLinkPayload",
    "kind": "LinkedField",
    "name": "infoAddContactLink",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "clientMutationId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "SearchContactsAddMutation",
    "selections": (v1/*: any*/),
    "type": "ApplicationCommand",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SearchContactsAddMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "d8a8e9d60f92d2afeeb6265089c34818",
    "id": null,
    "metadata": {},
    "name": "SearchContactsAddMutation",
    "operationKind": "mutation",
    "text": "mutation SearchContactsAddMutation(\n  $input: infoAddContactLinkInput!\n) {\n  infoAddContactLink(input: $input) {\n    clientMutationId\n  }\n}\n"
  }
};
})();
(node as any).hash = '1d8f34bb06c5551b2540d5489eaf657a';
export default node;
